import { UPDATE_PREFERRED_LANGUAGE } from "@api/mutationsV2/profile";
import { GET_PREFERRED_LANGUAGE } from "@api/queriesV2/profile";
import { getSupportedPreferredLanguage } from "@utils/preferredLanguage";

// These optional operations own their errors: no global retry, toast or logout.
async function request(client, method, options) {
  const controller = new AbortController();
  let timer;
  try {
    return await Promise.race([
      client[method]({
        ...options,
        errorPolicy: "none",
        context: {
          clientName: "v2",
          preferredLanguageOperation: true,
          queryDeduplication: false,
          fetchOptions: { signal: controller.signal },
        },
      }),
      new Promise((_, reject) => {
        timer = setTimeout(() => {
          reject(new Error("Preferred language request timed out"));
          controller.abort();
        }, 15000);
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}

export async function readPreferredLanguage(client) {
  const result = await request(client, "query", {
    query: GET_PREFERRED_LANGUAGE,
    fetchPolicy: "no-cache",
  });
  const value = result.data?.profile?.preferredLanguage;
  if (result.errors?.length || value === undefined) {
    throw new Error("Invalid preferred language response");
  }
  return getSupportedPreferredLanguage(value);
}

export async function updatePreferredLanguage(client, value) {
  if (!getSupportedPreferredLanguage(value)) {
    throw new Error("Unsupported preferred language");
  }
  const result = await request(client, "mutate", {
    mutation: UPDATE_PREFERRED_LANGUAGE,
    variables: { input: { preferredLanguage: value } },
  });
  // Missing data is not the nullable success response in this API.
  if (result.errors?.length || result.data?.partialUpdateProfile !== null) {
    throw new Error("Could not save preferred language");
  }
}
